export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20abstract%20artistic%20composition%20with%20warm%20coral%20red%20and%20golden%20amber%20gradients%20flowing%20dynamically%20across%20a%20soft%20cream%20background%2C%20subtle%20geometric%20shapes%20and%20organic%20curves%20blending%20harmoniously%2C%20modern%20editorial%20design%20aesthetic%20with%20gradient%20washes%20and%20textured%20overlays%2C%20no%20text%2C%20no%20people%2C%20clean%20abstract%20art%20style&width=1800&height=900&seq=hero-bg-51hl&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/10 via-background-50/20 to-background-50/70"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line text-base w-4 h-4 flex items-center justify-center"></i>
              实时更新 · 全网吃瓜第一站
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight mb-4">
              51黑料 - 你的吃瓜第一站
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading mb-6">
              汇集全网热门话题，随时随地畅享吃瓜乐趣
            </p>

            <div className="text-foreground-600 text-sm md:text-base leading-relaxed space-y-3 mb-8 max-w-xl mx-auto lg:mx-0">
              <p>
                51黑料网作为国内领先的娱乐资讯聚合平台，致力于为用户提供最新、最全、最热的娱乐话题与社区内容。从明星动态到社会热点，从独家爆料到全民热议，51黑料网站首页每日实时更新，确保你不错过任何一个精彩瞬间。
              </p>
              <p>
                平台覆盖影视综艺、音乐演出、综艺节目、体育赛事等多个垂直领域，通过51黑料官网入口即可一键触达全部核心栏目。51黑料网页版无需下载安装，登录即用，随时随地畅享沉浸式吃瓜体验。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">200+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新资讯</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">50+</div>
                <div className="text-xs text-foreground-500 mt-1">覆盖话题领域</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">7×24</div>
                <div className="text-xs text-foreground-500 mt-1">全天候更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line text-base w-4 h-4 flex items-center justify-center"></i>
                立即浏览最新资讯
              </a>
              <a
                href="#about"
                className="inline-flex items-center gap-2 px-8 py-3 border border-foreground-300 text-foreground-700 rounded-full font-medium text-sm hover:bg-foreground-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-base w-4 h-4 flex items-center justify-center"></i>
                了解51黑料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20editorial%20collage%20style%20composition%20featuring%20abstract%20tropical%20palm%20leaves%20and%20organic%20shapes%20in%20warm%20coral%20red%20and%20soft%20golden%20amber%20tones%20against%20a%20clean%20cream%20background%2C%20overlapping%20translucent%20geometric%20circles%20and%20flowing%20curves%2C%20magazine%20editorial%20layout%20aesthetic%2C%20sophisticated%20and%20trendy%2C%20no%20text%2C%20no%20people%2C%20high-end%20visual%20design&width=1200&height=900&seq=hero-main-51hl&orientation=landscape"
                alt="51黑料 - 娱乐资讯聚合平台主视觉"
                title="51黑料 - 娱乐资讯聚合平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-foreground-200/20"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}